import React from 'react'

import './PaymentBuilder.css'

export default function ExpandedPaymentScheduleRow({ date, amount, id }) {
	const formatter = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
	})

	return (
		<div className='payment-row'>
			<div>{id + 1}</div>
			<div>{date}</div>
			<div className='underline'></div>
			<div className='text-align-right'>{formatter.format(amount)}</div>
		</div>
	)
}
